import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

/**
 * StepKelipatanSection (presentational)
 * - UI input step untuk bar_chart / line_chart
 * - Parent tetap pegang rule kapan tampil + dispatch handler
 */
export default function StepKelipatanSection(props) {
  const { value, onChange, onWheel } = props;

  return (
    <>
      <small className="text-muted d-block">
        Sebaiknya jumlah jawaban tidak lebih dari 5 item untuk visualisasi yang optimal.
      </small>

      <FormGroup className="mb-3 mt-2">
        <Label for="validationStep" style={{ fontWeight: 'bold' }}>
          Step (Kelipatan):
        </Label>
        <Input
          className="form-control"
          id="validationStep"
          type="number"
          name="step"
          placeholder="Contoh: 5"
          min="1"
          step="1"
          value={value}
          onChange={onChange}
          onWheel={onWheel}
        />
        <small className="text-muted d-block">
          Dipakai untuk menentukan kelipatan skala (mis. 5, 10, 20).
        </small>
      </FormGroup>
    </>
  );
}